export class serviceWorkflow {
    id: number;
    serviceId: number;
    accountId: number;
    serviceOrder: number;
    isMandatory: boolean;
    status: boolean;
    serviceName: string;
    created: Date;
    lastUpdated: Date;
    isAdditionalServiceEnabled: boolean
    additionalServices: any = [];
}